import { IS_DEV_ENV, IS_CYPRESS_ENV } from "../../utils/constants";

const isTestEnvironment = process.env.NODE_ENV === "test";

const config: Record<string, any> = {};

// `supabaseUrl` should be the "url" from the supabase project settings
// `supabaseApiKey` should be the "anon key"
if (isTestEnvironment) {
  config.supabaseUrl = "";
  config.supabaseApiKey = "";
} else if (IS_DEV_ENV || IS_CYPRESS_ENV) {
  config.supabaseUrl = "https://dijetbunvxszevyhqsrl.supabase.co";
  config.supabaseApiKey = "sb_publishable_MWcobjKyASqE9yLRIuO3RA_WXl-QCU8";
} else {
  config.supabaseUrl = "https://dijetbunvxszevyhqsrl.supabase.co";
  config.supabaseApiKey = "sb_publishable_MWcobjKyASqE9yLRIuO3RA_WXl-QCU8";
}

export default config;
